import Pais from '../../../models/pais/pais'

export function setPais (pais) {
  return dispatch => {
    dispatch({ type: 'SET_PAIS', pais })
  }
};

export function requestPaises () {
  return dispatch => {
    dispatch({ type: 'REQUEST_PAISES' })
    return Pais.getPaises()
      .then(paises => {
        dispatch({
          type: 'RECEIVE_PAISES',
          paises })
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_PAISES',
        paises: []
      }))
  }
};
